// extracted by mini-css-extract-plugin
module.exports = {"container":"sign-button_container__EUtHx","disabled":"sign-button_disabled__gM7Ca","text":"sign-button_text__MOlBx"};